export default "__VITE_ASSET__Dtap9AzQ__"